import { styled } from '../../../../../../theme/styled';
import { RangeInputStateProps } from '../model';

export const RangeInputRoot = styled('div', {
  name: 'RangeInput',
  slot: 'Root',
})<{ ownerState: RangeInputStateProps }>(({ theme, ownerState }) => {
  if (ownerState.variant === 'minimal') {
    return {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      minWidth: 0,
    };
  }

  const borderRadius = `${theme.borderRadius.normal}px`;
  const hasValueInput = !ownerState.disableValueInput;

  return {
    position: 'relative',
    backgroundColor: 'inherit',
    margin: 0,
    border: hasValueInput ? `1px solid ${theme.palette[ownerState.error ? 'brand pink' : 'gray light']}` : 'none',
    borderBottom: hasValueInput ? 'none' : undefined,
    borderTopLeftRadius: hasValueInput ? borderRadius : undefined,
    borderTopRightRadius: hasValueInput ? borderRadius : undefined,

    '@media (pointer: fine)': {
      '&:hover': hasValueInput &&
        !ownerState.disabled &&
        !ownerState.error && {
          borderColor: theme.palette.gray,
        },
    },
  };
});
